import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, IsEmptyFilterOperatorComponent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { GridSettings, Info } from '../../../../core/common';
import { ISampleFinish, ISampleSubCategory, ISampleCategory, IGetSampleProductOrderDetailsByHeader, IGetSampleSubCategoryCostBySubcategoryId, IDiscItem, IMasterData, DiscItem } from '../../../../core/models';
import { AdminService } from '../../../../core/services/admin.service';
import { ProductSampleFulfillmentService } from '../../../../core/services/product-sample-fulfillment.service';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DiscountStoreService } from '../../../../core/services/discount-store.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  //#region member variables
  isClothCategory: boolean = false;
  finishSampleLoading: boolean;

  finishSampleForm: FormGroup;
  categorySaveInProcess: boolean;
  subCategorySaveInProcess: boolean;

  categoryData: ISampleCategory[];
  selectedCategory: string = ""
  selectedCategoryId: number;
  selectedGender: string = "";
  selectedSize: string = "";
  filePath: string;
  public infoMessage: Info = new Info();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  subCategoryFileUpload: string = "";
  addEditCategoryId: number = 0;
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif"],
  };
  isAddHideColumns: boolean = false;
  isEditHideColumns: boolean = false;
  isEditCategoryColumns: boolean = false;
  isEditedSampleSubCategory: boolean = false;
  isCopiedSampleSubCategory: boolean = false;
  sampleSubCategoryTitleText: string = '';
  sampleCategoryTitleText: string = '';
  costHeaderGridData: GridDataResult;
  costGridData: any[] = [];
  costLoading: boolean;
  isSampleSubCategoyCost: boolean;
  imageUrl: string;
  isDisableExternal: boolean = false;
  isPriceHistory: boolean = false;
  priceHistoryGridView: GridDataResult;
  rawData = null;
  isEditForExistingItem: boolean;
  isEditForNewItem: boolean;
  isEditDisabled: boolean;

  constructor(private adminService: AdminService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private discountStoreService: DiscountStoreService,
    private router: Router) {
    
  }

  ngOnInit() {
    this.initializeFormControls();
    this.initDealFlag();
    this.loadTestData();
    this.loadTestLocs();
    this.loadItems();
    this.isSampleSubCategoyCost = false;
    this.imageUrl = environment.imageUrl;
  }
  public uploadImage = false;
  public inputURL = false;
  public inputRGB = false;
  toggleUploadImage() {
    this.inputURL = false;
    this.inputRGB = false;
    this.uploadImage = true;
    //this.finishSampleForm.controls.fileUpload.setValue(null);
    this.finishSampleForm.controls.inputURL.setValue(null);
    this.finishSampleForm.controls.inputR.setValue(null);
    this.finishSampleForm.controls.inputG.setValue(null);
    this.finishSampleForm.controls.inputB.setValue(null);
    this.subCategoryFileUpload = "";
  }
  toggleInputURL() {
    this.uploadImage = false;
    this.inputRGB = false;
    this.inputURL = true;
    this.finishSampleForm.controls.fileUpload.setValue(null);
    //this.finishSampleForm.controls.inputURL.setValue(null);
    this.finishSampleForm.controls.inputR.setValue(null);
    this.finishSampleForm.controls.inputG.setValue(null);
    this.finishSampleForm.controls.inputB.setValue(null);
    this.subCategoryFileUpload = "";
    this.filePath = "";
  }
  toggleInputRGB() {
    this.inputURL = false;
    this.uploadImage = false;
    this.inputRGB = true;
    this.finishSampleForm.controls.fileUpload.setValue(null);
    this.finishSampleForm.controls.inputURL.setValue(null);
    //this.finishSampleForm.controls.inputR.setValue(null);
    //this.finishSampleForm.controls.inputG.setValue(null);
    //this.finishSampleForm.controls.inputB.setValue(null);
    this.subCategoryFileUpload = "";
    this.filePath = "";
  }

  protected costLblText = {
    subCategoryDescriptionLbl: 'Product Description',
    costLbl: 'Cost',
    effectiveFromLbl: 'Effective From',
    effectiveToLbl: 'Effective To',
    isCurrentCostLbl: 'Is Current Cost',
  };
  //#region import label declaration
  protected import = {
    uploadItemToExcelLbl: 'Upload Items From Excel',
    excelFileUploadLbl: 'Requirement for Excel file upload',
    importContentLbl1: 'You may add any contents (like text) in row 1. Contents for row 1 will not be uploaded',
    importContentLbl2: 'Data from row 2 upto row 1000 will be uploaded.',
    importContentLbl3: ' Column 1 must be the item name and column 2 must be item quantity.',
    importContentLbl4: 'Any aditional columns after column 2 will be iqnored.',
    importContentLbl5: 'A maximum of 999 items can be uploaded at one time from Excel. Any rows after row 1000 in the Excel file will be ignored.',
    importContentLbl6: 'To upload more than 999 items, you must upload them in multiple batches with a maximum of 999 items at a time.',
    importContentLbl7: 'Note that you can not upload configured items or kit items.',
    importContentLbl8: 'Item quantity (column 2) must be between 1 to 999.',
    importContentLbl9: 'A sheet name is mandatory.Enter the correct sheet name.',
    importContentLbl10: 'To download a sample Excel file,',
    importContentLbl11: 'Enter the Excel Details below and then click',
    clickLbl: 'Click',
    uploadLbl: 'Upload',
    importSuccessMessageLbl: 'Uploading.......',
    importSuccessMessageLbl1: 'All Item successfully added to Cart',
    errorMessage: 'Cannot use multiple files',
  }
  //#endregion
  importDialog = {
    opened: false
  }
  importDialogOpen() {
    //this.importDialog.opened = !this.importDialog.opened;
    this.router.navigate(['discount-store/admin/import-item']);

  }
  public costGridstate: State = {
    skip: 0,
    take: 5,
    group: null,
    sort: [{
      field: 'subCategoryId',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  //#region All column settings for the Grid
  public costGridSettings: GridSettings = {
    state: this.costGridstate,
    gridData: process(this.costGridData, this.costGridstate),
    columnsConfig: [
      //  {
      //  field: 'subCategoryDescription',
      //  title: this.costLblText.subCategoryDescriptionLbl,
      //  filterable: true,
      //  _width: 50,
      //},
      {
        field: 'cost',
        title: this.costLblText.costLbl,
        filterable: true,
        _width: 80,
      },
      {
        field: 'effectiveFrom',
        title: this.costLblText.effectiveFromLbl,
        filter: 'date',
        format: '{0:d}',//not able to get from and to
        _width: 100,
        filterable: true,
      },
      {
        field: 'effectiveTo',
        title: this.costLblText.effectiveToLbl,
        filter: 'date',
        format: '{0:d}',//not able to get from and to
        _width: 100,
        filterable: true,
      },
      //  {
      //  field: 'isCurrentCost',
      //  title: this.costLblText.isCurrentCostLbl,
      //  //_width: 200,
      //  filterable: false,
      //  _width: 80,
      //}
    ]
  };
  //#endregion

  //#region save success label common code
  initilizeSuccessLabel() {
    this.inProgressMessage = true;
    this.infoMessage.genericSuccess = "";
    this.infoMessage.genericError = "";
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
  }

  //#endregion
  //#region kendo upload 
  sampleRequestImageSelected(evt: SelectEvent) {
  }
  sampleRequestUploadSuccess(evt: SuccessEvent) {
    this.subCategoryFileUpload = evt.response.body.paths[0];
  }
  //#endregion
  //#region Sample Request Grid Section
  //#region label and variable declaration

  finishSampleLbl = {
    longItemNumber: "Long Item #",
    shortItemNumber: "Item #",
    categoryName: "Item #",
    subCategoryDescription: "Description",
    description: "Description",
    colorCode: "Location",
    location: "Ships From",
    stockNum: "Available Qty",
    avlQty: "Available Qty",
    currentCostId: "Base Price",
    basePrice: "Base Price",
    cost: "Cost",
    discount: "Discount",
    salePrice: "Sale Price",
    finishCode: "Finish",
    size: "Size",
    paintCode: "Paint",
    createdDate: "DateAdded",

    maxQtyCanBeOrdered: "Max Qty",
    maxQtyCanBeOrderedAddText: "Max Quantity",

    stockNumAddText: "Stock Number",

    currentInventory: "Inventory",
    currentInventoryAddText: "Current Inventory",
    reorderPoint: "Reorder Point",
    stockingLevel: "Stocking Level",
    ec: "EC",
    onBackOrder: "On Backorder",
    isActive: "IsActive",
    resetTo: "Reset To",
    adjustment: "Adjustment +/-",
    isExternal: "External",
    isPDM: "PDM Only",
    action: "Actions",
    fileupload: "File Upload",
    urlLbl: "Url",
    skulbl: "SKU",
    updateAction: "Update",
    historyAction: "History",
    infoCategoryText: "*Note: This will update the existing category including the associated products",
    infoMaxQuantityText: "Max Quantity is optional",
    dimensions: "Item Box Dimensions (inches)",
    height: "Height",
    length: "Length",
    width: "Width",
    weight: "Weight(oz)",
    isEmptyCategoryDescription: false,
    isSubmitted: false,

    isEmptyCategory: false,
    isEmptySubCategory: false,
    isEmptyMaxqty: false,
    isEmptysku: false,
    isEmptyFinishCode: false,
    isEmptyFileUpload: false,
    isEmptyStockNum: false,
    isEmptyReorderPoint: false,
    isEmptyCurrentCostId: false,
    isEmptyStockingLevel: false,
    isEmptyCurrentInventory: false,

    isEmptyDescription: false,
    isEmptyLocation: false,
    isEmptyItemNumber: false,
    isEmptyPaintCode: false,


  }





  //#region Grid data binding
  private loadFinishSampleGrid(): void {
    this.finishSampleLoading = true;
    this.productSampleFulfillmentService.getSampleSubCategories().subscribe((response) => {
      this.bindItemGrid();
      this.finishSampleLoading = false;

    });
  }
  //#endregion

  //#region pagination, sorting,filtering for grid


  //private bindFinishSampleGrid(): void {
  //  const data = this.productSampleFulfillmentService.sampleSubCategory;

  //  this.finishSampleGridView = process(data, this.finishSampleGridstate);
  //  let filterArray = this.productSampleFulfillmentService.sampleSubCategory;
  //  let tempArray = filterArray.filter((v, i, a) => a.findIndex(t => (t.categoryId === v.categoryId)) === i);
  //  tempArray = tempArray.sort((a, b) => a.categoryName > b.categoryName ? 1 : -1);
  //  this.categoryData = tempArray as ISampleCategory[];
  //}

  protected finishSampleGridSortChange(sort: SortDescriptor[]): void {
    this.itemGridstate.sort = sort;
    this.bindItemGrid();
  }
  protected finishSampleGridPageChange({ skip, take }: PageChangeEvent): void {
    this.itemGridstate.skip = skip;
    this.itemGridstate.take = take;
    this.bindItemGrid();
  }

  public finishSampleDataStateChange(state: DataStateChangeEvent): void {
    this.itemGridstate = state;
    this.bindItemGrid();
  }
  //#endregion

  //#endregion



  //#region Correctly Updated section


  addItem() { }
  editItem() { }


  uuidv4() {
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16;//random number between 0 and 16
      if (d > 0) {//Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {//Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  locationList: IMasterData[];

  //#endregion

  //#region Sub Category(Finish) dialog operations

  categoryChange(event) {        //For now  Harcoded value written for Clothing Category.
    let categoryId = event.categoryId;
    if (categoryId == 12000) {
      this.isClothCategory = true;
    }
    else {
      this.isClothCategory = false;
    }

  }

  finishSampleDialog = {
    opened: false,

  }


  isValidateCostSwitch() {
    var controls = this.finishSampleForm.controls;
    if (controls.isCostHistory.value) {
      this.isSampleSubCategoyCost = true;
    }
    else {
      this.isSampleSubCategoyCost = false;
    }
  }

  getAllSampleSubCategoryCostHistory(id: number) {
    this.costLoading = true;
    const body: IGetSampleSubCategoryCostBySubcategoryId = {
      subCategoryId: id,
    }

    this.productSampleFulfillmentService.getAllSampleSubCategoryCostHistory(body).subscribe((response: Array<any>) => {
      if (response) {
        console.log(response);
        this.costGridData = response;
        this.productSampleFulfillmentService.setCostHeaderGridData(this.costGridData);
        this.loadCostHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while loading the page.');
    })
    this.costLoading = false;
  }

  private loadCostHeaderGridData(): void {
    if (this.costGridSettings.state)
      this.costHeaderGridData = process(this.costGridData, this.costGridSettings.state);
    else
      this.costHeaderGridData = process(this.costGridData, this.costGridstate);
    this.costGridSettings.gridData = this.costHeaderGridData;
  }
  protected costHeaderGridSortChange(sort): void {
    this.costGridstate.sort = sort;
    this.loadCostHeaderGridData();
  }

  protected costHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.costGridstate.skip = skip;
    this.costGridstate.take;
    this.loadCostHeaderGridData();
  }

  public costHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.costGridstate = state;
    this.costGridSettings.state = this.costGridstate;
    this.loadCostHeaderGridData();
  }

  editFinishCopySample(data: ISampleSubCategory) {
    this.sampleSubCategoryTitleText = "Copied from Sample Sub Category";
    this.isAddHideColumns = true;
    this.isEditHideColumns = false;
    this.isEditedSampleSubCategory = false;
    this.isCopiedSampleSubCategory = true;
    this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
    if (this.finishSampleDialog.opened == true) {
      this.finishSampleForm.controls.subCategoryId.setValue(null);
      this.selectedCategory = data.categoryName;
      this.selectedCategoryId = data.categoryId;
      this.finishSampleForm.controls.subCategory.setValue('Copied from ' + data.subCategoryDescription);
      //this.finishSampleForm.controls.sku.setValue(data.sku);
      this.finishSampleForm.controls.ec.setValue(data.ec);
      if (data.maxQtyCanBeOrdered == 99999)
        this.finishSampleForm.controls.maxQty.setValue(null);
      else
        this.finishSampleForm.controls.maxQty.setValue(data.maxQtyCanBeOrdered);
      this.finishSampleForm.controls.colorCode.setValue(data.colorCode);
      this.finishSampleForm.controls.stockNum.setValue(null);
      this.finishSampleForm.controls.currentCostId.setValue(data.currentCostId);
      this.finishSampleForm.controls.stockingLevel.setValue(data.stockingLevel);
      this.finishSampleForm.controls.currentInventory.setValue(data.currentInventory);
      this.finishSampleForm.controls.reorderPoint.setValue(data.reorderPoint);
      this.finishSampleForm.controls.isActive.setValue(data.isActive);
      this.inputRGB = false;
      this.inputURL = false;
      this.uploadImage = false;
      if (data.r_VALUE) {
        this.inputRGB = true;
        this.inputURL = false;
        this.uploadImage = false;
      }
      else if (data.imagePath) {
        this.inputRGB = false;
        this.inputURL = false;
        this.uploadImage = true;
      }
      else if (data.absoluteURL) {
        this.inputURL = true;
        this.uploadImage = false;
        this.inputRGB = false;
      }
      this.finishSampleForm.controls.inputR.setValue(data.r_VALUE);
      this.finishSampleForm.controls.inputG.setValue(data.g_VALUE);
      this.finishSampleForm.controls.inputB.setValue(data.b_VALUE);
      this.finishSampleForm.controls.inputURL.setValue(data.absoluteURL);

      this.finishSampleForm.controls.fileUrlPath.setValue(data.imagePath);
      this.filePath = data.imagePath;
      this.subCategoryFileUpload = data.imagePath; //assigning here the URL path
      if (this.selectedCategoryId == 12000) {
        this.isClothCategory = true;
      }
      else {
        this.isClothCategory = false;
      }
      this.finishSampleForm.controls.isPDM.setValue(data.isVisibleToOnlyPDMTeam);
      this.finishSampleForm.controls.isExternal.setValue(data.isVisibleToExternalUser);
      this.finishSampleForm.controls.isOnBackOrder.setValue(data.onBackOrder);
      this.finishSampleForm.controls.width.setValue(data.width);
      this.finishSampleForm.controls.height.setValue(data.height);
      this.finishSampleForm.controls.length.setValue(data.length);
      this.finishSampleForm.controls.weight.setValue(data.weight);
      if (this.finishSampleForm.controls.isPDM.value) {
        this.isDisableExternal = true;
      }
      else {
        this.isDisableExternal = false;
      }
    } else {
      //reset
      this.resetSubCategoryForm();
    }
  }

  protected validateSubCategoryForm(): boolean {
    let isValid = true;
    const controls = this.finishSampleForm.controls;
    if (this.finishSampleLbl.isSubmitted) {
      const t = controls.category.value ? controls.category.value.categoryName : "";
      if (t) {
        this.finishSampleLbl.isEmptyCategory = false;
      } else {
        this.finishSampleLbl.isEmptyCategory = true;
        isValid = false;
      }

      if (controls.subCategory.value) {
        this.finishSampleLbl.isEmptySubCategory = false;
      } else {
        this.finishSampleLbl.isEmptySubCategory = true;
        isValid = false;
      }

      //if (controls.maxQty.value) {
      //  this.finishSampleLbl.isEmptyMaxqty = false;
      //} else {
      //  this.finishSampleLbl.isEmptyMaxqty = true;
      //  isValid = false;
      //}

      if (controls.stockNum.value) {
        this.finishSampleLbl.isEmptyStockNum = false;
      } else {
        this.finishSampleLbl.isEmptyStockNum = true;
        isValid = false;
      }

      if (controls.currentCostId.value) {
        this.finishSampleLbl.isEmptyCurrentCostId = false;
      } else {
        this.finishSampleLbl.isEmptyCurrentCostId = true;
        isValid = false;
      }
      if (controls.stockingLevel.value) {
        this.finishSampleLbl.isEmptyStockingLevel = false;
      }
      else if (controls.stockingLevel.value == 0) {
        this.finishSampleLbl.isEmptyStockingLevel = false;
      } else {
        this.finishSampleLbl.isEmptyStockingLevel = true;
        isValid = false;
      }

      if (controls.currentInventory.value) {
        this.finishSampleLbl.isEmptyCurrentInventory = false;
      }
      else if (controls.currentInventory.value == 0) {
        this.finishSampleLbl.isEmptyCurrentInventory = false;
      }
      else {
        this.finishSampleLbl.isEmptyCurrentInventory = true;
        isValid = false;
      }
      if (controls.reorderPoint.value) {
        this.finishSampleLbl.isEmptyReorderPoint = false;
      } else {
        this.finishSampleLbl.isEmptyReorderPoint = true;
        isValid = false;
      }

      // if (controls.sku.value) {
      //   this.finishSampleLbl.isEmptysku = false;
      //} else {
      //  this.finishSampleLbl.isEmptysku = true;
      //  isValid = false;
      //}

      //if (controls.fileUpload.value) {
      //  this.finishSampleLbl.isEmptyFileUpload = false;
      //} else {
      //  this.finishSampleLbl.isEmptyFileUpload = true;
      //  isValid = false;
      //}

      //if (this.isClothCategory) {
      //  if (controls.gender.value.name != "") {
      //    this.finishSampleLbl.isEmptyGender = false;
      //  } else {
      //    this.finishSampleLbl.isEmptyGender = true;
      //    isValid = false;
      //  }

      //  if (controls.size.value.name != "") {
      //    this.finishSampleLbl.isEmptySize = false;
      //  } else {
      //    this.finishSampleLbl.isEmptySize = true;
      //    isValid = false;
      //  }
      //}

    }
    return isValid;
  }

  updateInventorySampleSubCategory() {
    //Validate
    var controls = this.finishSampleForm.controls;
    if (controls.resetTo.value == null && controls.adjustment.value == null) {
      return true;
    }
    this.subCategorySaveInProcess = true;
    //Update Inventory value
    let updatedInventory = 0;
    let resetVal = controls.resetTo.value;
    if (resetVal != null) {
      if (resetVal >= 0) {
        updatedInventory = Number(controls.resetTo.value);
      }
    }
    else if (controls.adjustment.value) {
      updatedInventory = Number(controls.currentInventory.value) + Number(controls.adjustment.value);
    }
    else {
      updatedInventory = Number(controls.currentInventory.value);
    }
    //set on Back Order
    if (updatedInventory <= 0) {
      this.finishSampleForm.controls.isOnBackOrder.setValue(true);
    } else {
      this.finishSampleForm.controls.isOnBackOrder.setValue(false);
    }
    //set Is external
    if (controls.isPDM.value) {
      this.finishSampleForm.controls.isExternal.setValue(false);
    }
    const body: ISampleSubCategory = {
      subCategoryId: controls.subCategoryId.value ? controls.subCategoryId.value : 0,
      categoryId: controls.category.value.categoryId,
      categoryName: controls.category.value.categoryName,
      sku: 0,
      subCategoryDescription: controls.subCategory.value,
      maxQtyCanBeOrdered: Number(controls.maxQty.value),
      ec: controls.ec.value,
      colorCode: controls.colorCode.value,
      stockNum: controls.stockNum.value,
      currentCostId: controls.currentCostId.value,
      stockingLevel: controls.stockingLevel.value,
      currentInventory: updatedInventory,
      reorderPoint: controls.reorderPoint.value,
      //absoluteURL: controls.inputURL.value,
      r_VALUE: controls.inputR.value,
      b_VALUE: controls.inputB.value,
      g_VALUE: controls.inputG.value,
      imagePath: this.subCategoryFileUpload, //passing selected file URL here      
      displayOrder: 0,
      isActive: controls.isActive.value ? controls.isActive.value : false,
      isVisibleToOnlyPDMTeam: controls.isPDM.value ? controls.isPDM.value : false,
      isVisibleToExternalUser: controls.isExternal.value ? controls.isExternal.value : false,
      onBackOrder: controls.isOnBackOrder.value ? controls.isOnBackOrder.value : false,
      isActiveCategory: false,
      absoluteURL: controls.inputURL.value,
      width: controls.width.value ? controls.width.value : 0,
      length: controls.length.value ? controls.length.value : 0,
      height: controls.height.value ? controls.height.value : 0,
      weight: controls.weight.value ? controls.weight.value : 0
    }

    this.productSampleFulfillmentService.UpdateInventorySampleSubCategory(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.subCategorySaveInProcess = false;
      if (response) {
        if (response.subCategoryId > 0 && this.isEditedSampleSubCategory) {
          this.finishSampleForm.controls.resetTo.setValue(null);
          this.finishSampleForm.controls.adjustment.setValue(null);
          this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
          this.editFinishSample(response);
        } else {
          this.resetSubCategoryForm();
        }
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadFinishSampleGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    });

  }



  saveSampleRequestSubCategory() {
    this.finishSampleLbl.isSubmitted = true;
    if (!this.validateSubCategoryForm()) {
      return;
    }

    this.initilizeSuccessLabel();
    this.subCategorySaveInProcess = true;

    var controls = this.finishSampleForm.controls;
    let inventory = Number(controls.currentInventory.value);
    //set on Back Order
    if (inventory <= 0) {
      this.finishSampleForm.controls.isOnBackOrder.setValue(true);
    } else {
      this.finishSampleForm.controls.isOnBackOrder.setValue(false);
    }
    //set Is external
    if (controls.isPDM.value) {
      this.finishSampleForm.controls.isExternal.setValue(false);
    }
    const body: ISampleSubCategory = {
      subCategoryId: controls.subCategoryId.value ? controls.subCategoryId.value : 0,
      categoryId: controls.category.value.categoryId,
      categoryName: controls.category.value.categoryName,
      sku: 0,
      subCategoryDescription: controls.subCategory.value,
      maxQtyCanBeOrdered: Number(controls.maxQty.value),
      ec: controls.ec.value,
      colorCode: controls.colorCode.value,
      stockNum: controls.stockNum.value,
      currentCostId: controls.currentCostId.value,
      stockingLevel: controls.stockingLevel.value,
      currentInventory: controls.currentInventory.value,
      reorderPoint: controls.reorderPoint.value,
      //absoluteURL: controls.inputURL.value,
      r_VALUE: controls.inputR.value,
      b_VALUE: controls.inputB.value,
      g_VALUE: controls.inputG.value,
      imagePath: this.subCategoryFileUpload, //passing selected file URL here      
      displayOrder: 0,
      isActive: controls.isActive.value ? controls.isActive.value : false,
      isVisibleToOnlyPDMTeam: controls.isPDM.value ? controls.isPDM.value : false,
      isVisibleToExternalUser: controls.isExternal.value ? controls.isExternal.value : false,
      onBackOrder: controls.isOnBackOrder.value ? controls.isOnBackOrder.value : false,
      isActiveCategory: false,
      absoluteURL: controls.inputURL.value,
      width: controls.width.value ? controls.width.value : 0,
      length: controls.length.value ? controls.length.value : 0,
      height: controls.height.value ? controls.height.value : 0,
      weight: controls.weight.value ? controls.weight.value : 0
    }

    //Valdiate Sample sub category with stock
    //if (controls.subCategoryId.value == null || controls.subCategoryId.value == 0) {
    //  //var test = this.isSubCategoryExist();
    //  const stockBody: ISampleSubCategoryExist = {
    //    stockNumber: controls.stockNum.value
    //  }
    //   this.productSampleFulfillmentService.GetSampleSubCatgeoryExist(stockBody).subscribe((response: any) => {
    //    console.log(response);
    //    if (response.length > 0) {
    //      this.infoMessage.genericInProgress = "";
    //      this.infoMessage.genericError = "Sample Sub Category already exist with the stock number";
    //      this.subCategorySaveInProcess = false;
    //      alert('step1 stock');
    //      return;
    //    }
    //  });  
    //}    

    this.productSampleFulfillmentService.AddUpdateSampleSubCategory(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.subCategorySaveInProcess = false;
      if (response) {
        if (response.subCategoryId > 0 && this.isEditedSampleSubCategory) {
          this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
          this.editFinishSample(response);
        } else {
          this.resetSubCategoryForm();
        }
        this.successMessage = true;
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        this.loadFinishSampleGrid();

      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }

    });

  }

  validateSubCategoryOnBackOrder() {
    var controls = this.finishSampleForm.controls;
    if (controls.currentInventory.value <= 0) {
      this.finishSampleForm.controls.isOnBackOrder.setValue(true);
    }
    else {
      this.finishSampleForm.controls.isOnBackOrder.setValue(false);
    }
  }
  validateSubCategoryIsExternal() {
    var controls = this.finishSampleForm.controls;
    if (controls.isPDM.value) {
      this.isDisableExternal = true;
      this.finishSampleForm.controls.isExternal.setValue(false);
    }
    else {
      this.finishSampleForm.controls.isExternal.setValue(false);
      this.isDisableExternal = false;
    }
  }
  
  resetSubCategoryForm() {
    this.finishSampleLbl.isSubmitted = false;
    this.finishSampleForm.reset();
    this.finishSampleLbl.isEmptyCategory = false;
    this.finishSampleLbl.isEmptySubCategory = false;
    this.finishSampleLbl.isEmptyMaxqty = false;
    this.finishSampleLbl.isEmptyFinishCode = false;
    this.selectedCategory = "";
    this.selectedCategoryId = 0;
    this.selectedGender = "";
    this.selectedSize = "";
    this.subCategorySaveInProcess = false;
    this.infoMessage = new Info();
    this.isClothCategory = false;
    this.finishSampleForm.controls.isActive.setValue(true);

    this.finishSampleLbl.isEmptyFileUpload = false;
    this.filePath = "";
    this.subCategoryFileUpload = "";
    this.isEditedSampleSubCategory = false;
    this.isCopiedSampleSubCategory = false;
    this.uploadImage = false;
    this.finishSampleForm.controls.fileUpload.setValue(null);
    this.isDisableExternal = false;
    //this.sampleSubCategoryTitleText = "";
  }
  lid: any;
  lname: any;
  editFinishSample(data: IDiscItem) {
    this.sampleSubCategoryTitleText = "Edit Item";
    this.isAddHideColumns = false;
    this.isEditHideColumns = true;
    this.isEditedSampleSubCategory = true;
    this.isCopiedSampleSubCategory = false;
    this.isSampleSubCategoyCost = false;
    this.finishSampleDialog.opened = !this.finishSampleDialog.opened;
    if (this.finishSampleDialog.opened == true) {

      this.finishSampleForm.controls.itemId.setValue(data.itemId);
      this.finishSampleForm.controls.itemNumber.setValue(data.itemNumber);
      this.finishSampleForm.controls.finishCode.setValue(data.finishCode);
      this.finishSampleForm.controls.size.setValue(data.size);
      this.finishSampleForm.controls.paintCode.setValue(data.paintCode);
      this.finishSampleForm.controls.avlQty.setValue(data.currentInventory);
      this.finishSampleForm.controls.basePrice.setValue(data.basePrice);
      this.finishSampleForm.controls.discount.setValue(data.discount);
      this.finishSampleForm.controls.salePrice.setValue(data.salePrice);
      this.finishSampleForm.controls.isActive.setValue(data.isActive);
      this.finishSampleForm.controls.description.setValue(data.description);
      this.finishSampleForm.controls.createdDate.setValue(data.createdDate.split(' ')[0]);
      this.lid = data.availableLocId;
      this.lname = data.availableLocName;
      this.finishSampleForm.controls.location.setValue({ id: data.availableLocId, name: data.availableLocName });

    }
  }

  //#endregion
  //#region Home Grid

  allItems: IDiscItem[] = [];
  itemGridView: GridDataResult;
  public itemGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'longItemNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  async loadItems() {
    try {
      let resp = await this.discountStoreService.getAllItems().toPromise();
      this.allItems = resp;
      this.bindItemGrid();
    }
    catch (err) { }
  }

  private bindItemGrid(): void {
    this.itemGridView = process(this.allItems, this.itemGridstate);
  }

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete the item ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem;
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.removeHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  protected async removeHandler() {
    const itemId = this.gridItemToRemove.itemId;
    try {
      const resp = await this.discountStoreService.deleteItem(itemId).toPromise();
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected Item has been removed.");
    }
    catch (err) { }
    await this.loadItems();
  }

  //#endregion
  //#endregion
  //#region Add/Edit Items
  openEditItemDialog(item: IDiscItem) {
    this.sampleSubCategoryTitleText = "Edit Item";
    this.isEditForExistingItem = true;
    this.isEditForNewItem = false;
    this.finishSampleDialog.opened = true;
    this.initializeFormForEditingItem(item);
  }
  initializeFormForEditingItem(data: IDiscItem) {
    this.sampleSubCategoryTitleText = "Edit Item";
    this.emptyValidationItemForm();
    this.finishSampleForm.controls.itemId.setValue(data.itemId);
    this.finishSampleForm.controls.longItemNumber.setValue(data.longItemNumber);
    this.finishSampleForm.controls.itemNumber.setValue(data.itemNumber);
    this.finishSampleForm.controls.description.setValue(data.description);
    this.finishSampleForm.controls.finishCode.setValue(data.finishCode);
    this.finishSampleForm.controls.size.setValue(data.size);
    this.finishSampleForm.controls.paintCode.setValue(data.paintCode);
    this.finishSampleForm.controls.basePrice.setValue(data.basePrice);
    this.finishSampleForm.controls.discount.setValue(data.discount);
    this.finishSampleForm.controls.salePrice.setValue(data.salePrice);
    this.finishSampleForm.controls.currentInventory.setValue(data.currentInventory);
    this.finishSampleForm.controls.isActive.setValue(data.isActive);
    this.finishSampleForm.controls.location.setValue({ value: data.availableLocId, name: data.availableLocName });
    this.finishSampleForm.controls.createdDate.setValue(data.createdDate.split(' ')[0]);
    this.lid = data.availableLocId;
    this.lname = data.availableLocName;
  }
  initializeFormForAddingItem() {
    this.initializeFormControls();
  }
  initializeFormControls() {
    this.finishSampleForm = this.formBuilder.group({
      itemId: new FormControl(""),
      longItemNumber: new FormControl(""),
      itemNumber: new FormControl(""),
      description: new FormControl(""),
      finishCode: new FormControl(""),
      size: new FormControl(""),
      paintCode: new FormControl(""),
      location: new FormControl(""),
      basePrice: new FormControl(),
      discount: new FormControl(),
      salePrice: new FormControl(),
      currentInventory: new FormControl(),
      isActive: new FormControl(),
      createdDate: new FormControl()
    });
  }
  openAddItemDialog() {
    this.sampleSubCategoryTitleText = "Add Item";
    this.isEditForExistingItem = false;
    this.isEditForNewItem = true;
    this.finishSampleDialog.opened = true;
    this.resetDiscountItemForm();
  }
  async closeItemUpdateDialog() {
    this.finishSampleDialog.opened = false;
    this.initializeFormControls();
    this.lid = "";
    this.lname = "";
    this.emptyValidationItemForm();
    this.infoMessage = new Info();
    //reload item grid
    await this.loadItems();
  }
  async saveItem() {
    this.finishSampleLbl.isSubmitted = true;
    var controls = this.finishSampleForm.controls;

    const body: DiscItem = {
      itemId: controls.itemId.value,
      itemNumber: controls.itemNumber.value,
      longItemNumber: controls.itemNumber.value,
      size: controls.size.value,
      finishCode: controls.finishCode.value,
      paintCode: controls.paintCode.value,
      currentInventory: Number(controls.currentInventory.value),
      basePrice: controls.basePrice.value ? controls.basePrice.value : 0,
      discount: controls.discount.value ? controls.discount.value : 0,
      salePrice: controls.salePrice.value ? controls.salePrice.value : 0,
      availableLocId: controls.location.value.value,
      availableLocName: controls.location.value.name,
      isActive: controls.isActive.value ? controls.isActive.value : false,
      orderQty: -1,//remove this
      description: controls.description.value,
      createdDate:  ''
    }

    if (body.finishCode && body.finishCode.length > 0) {
      body.longItemNumber = body.longItemNumber + "-" + body.finishCode;
    }

    if (body.size && body.size.length > 0) {
      body.longItemNumber = body.longItemNumber + "-" + body.size;
    }

    if (body.paintCode && body.paintCode.length > 0) {
      body.longItemNumber = body.longItemNumber + " #" + body.paintCode;
    }

    if (!this.validateDiscountItemForm()) {
      return;
    }

    //Duplicate Validation For Long Item Number
    if (body.itemId == null || body.itemId == '') {
      var tempLongItemNumber = this.allItems.filter(x => x.longItemNumber == body.longItemNumber && x.availableLocName == body.availableLocName)
      if (tempLongItemNumber.length > 0) {
        this.infoMessage.genericError = "Item already exist with Long Item number and Location";
        this.infoMessage.genericInProgress = "";
        this.subCategorySaveInProcess = false;
        this.finishSampleLbl.isSubmitted = false;
        return;
      }
    }         
    let lngItem = "";
    console.log(controls);
    //let ops = 'add';
    //if (controls.itemId.value && controls.itemNumber.value.length > 0) {
    //  ops = 'edit';
    //}

    
    try {
      this.subCategorySaveInProcess = true;
      var info = new Info();
      let resp = await this.discountStoreService.saveItem(body).toPromise();
      this.initilizeSuccessLabel();
      this.infoMessage.genericSuccess = this.infoMessage.successMessage;
    }
    catch (err) {
      this.infoMessage.genericError = this.infoMessage.genericError;
    }
    this.subCategorySaveInProcess = false;
    this.finishSampleLbl.isSubmitted = false;
    this.infoMessage.genericInProgress = "";
    if (body.itemId == null || body.itemId == '')
      this.resetDiscountItemForm();
    this.loadItems();
  }

  prepareLongItemName() {
    //console.log(e);

    let itemName = this.finishSampleForm.controls.itemNumber.value;
    let finishCode = this.finishSampleForm.controls.finishCode.value;
    let size = this.finishSampleForm.controls.size.value;
    let paintCode = this.finishSampleForm.controls.paintCode.value;
    let longItemNumber = itemName;
    if (itemName) {
      if (finishCode && finishCode.length > 0) {
        longItemNumber = longItemNumber + "-" + finishCode;
      }

      if (size && size.length > 0) {
        longItemNumber = longItemNumber + "-" + size;
      }

      if (paintCode && paintCode.length > 0) {
        longItemNumber = longItemNumber + " #" + paintCode;
      }
    }
    console.log(longItemNumber);
    this.finishSampleForm.controls.longItemNumber.setValue(longItemNumber);
  }
  //#endregion

  //#region Deal Switch
  switchDealToggle: boolean = false;
  showDealFlagWarningMessage: boolean = false;
  async handleDealSwitchToggle(event: boolean) {
    console.log("Deal is on=" + this.switchDealToggle);
    this.showDealFlagWarningMessage = true;
    //show a spinner while the update is happening
    try {
      //let resp = this.discountStoreService.handleDealSwitchToggle(event).toPromise();
    }
    catch { }
  }

  closeDealToggleConfirmationBox() {
    //do nothing and revert back to previous state
    this.showDealFlagWarningMessage = false;
    this.switchDealToggle = !this.switchDealToggle;
  }

  async proceedToUpdateDealFlag() {
    let resp;
    try {
      resp = await this.discountStoreService.handleDealSwitchToggle(this.switchDealToggle).toPromise();
      //if success good
      //else show some message, request to try again
    }
    catch (e) { }
    this.showDealFlagWarningMessage = false;
  }

  async initDealFlag() {
    let resp;
    try {
      resp = await this.discountStoreService.getDealFlag().toPromise();
      //if success good
      //else show some message, request to try again
    }
    catch (e) { }
    this.switchDealToggle = resp;
  }

  //#endregion

  //#region Test Data
  lc_key = "DiscountedItems";
  loadTestData() {
    this.allItems = JSON.parse(localStorage.getItem(this.lc_key));
    if (!this.allItems) {
      this.allItems = [];
    }
  }
  async loadTestLocs() {
    this.locationList = [];
    try {
      this.locationList = await this.discountStoreService.getAllLocationsForOrderClearance().toPromise();
    }
    catch (err) { }
  }
  redirecttoOrderHistory() {
    this.router.navigate(['discount-store/admin/order-history']);
  }
  resetDiscountItemForm() {
    this.finishSampleLbl.isSubmitted = false;
    this.finishSampleForm.reset();
    this.finishSampleForm.controls.isActive.setValue(true);
    this.emptyValidationItemForm();
  }
  emptyValidationItemForm() {
    this.finishSampleLbl.isEmptyDescription = false;
    this.finishSampleLbl.isEmptyLocation = false;
    this.finishSampleLbl.isEmptyItemNumber = false;
    this.finishSampleLbl.isEmptyPaintCode = false;
  }
  protected validateDiscountItemForm(): boolean {
    let isValid = true;
    const controls = this.finishSampleForm.controls;
    if (this.finishSampleLbl.isSubmitted) {
      if (controls.description.value) {
        this.finishSampleLbl.isEmptyDescription = false;
      } else {
        this.finishSampleLbl.isEmptyDescription = true;
        isValid = false;
      }

      const locationDropdown = controls.location.value ? controls.location.value.value : "";
      if (locationDropdown) {
        this.finishSampleLbl.isEmptyLocation = false;
      } else {
        this.finishSampleLbl.isEmptyLocation = true;
        isValid = false;
      }          

      if (controls.itemNumber.value) {
        this.finishSampleLbl.isEmptyItemNumber = false;
      } else {
        this.finishSampleLbl.isEmptyItemNumber = true;
        isValid = false;
      }
      if (controls.finishCode.value == '22') {
        if (controls.paintCode.value) {
          this.finishSampleLbl.isEmptyPaintCode = false;
        } else {
          this.finishSampleLbl.isEmptyPaintCode = true;
          isValid = false;
        }
      } else {
        this.finishSampleLbl.isEmptyPaintCode = false;
      }

    }
    return isValid;
  }
  //#endregion

  // #region Price History

  public priceHistoryState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'createdDate'
    }]
  };
  
  public async processPriceHistoryGridData(dataItem) {
    console.log("dataItem: ", dataItem);
    // data call here
    this.discountStoreService.getPriceHistoryForItem(dataItem).subscribe(resp => {

      console.log(resp); // data comes here without issue
      this.rawData = resp;
      console.log("price hist data: ", this.rawData);
      this.bindPriceHistoryGrid();

      this.openPriceHistory();
    })

    

/*      [{ date: "4/22/2025", price: 25 }, { date: "4/20/2025", price: 20 }, { date: "4/18/2025", price: 18 }];*/
 }

  bindPriceHistoryGrid() {
    this.priceHistoryGridView = process(this.rawData, this.priceHistoryState);
  }

  public closePriceHistory(): void {
    this.isPriceHistory = false;
  }
  public openPriceHistory(): void {
    this.isPriceHistory = true;
  }

  // #endregion

  public isItemEditDisabled(): boolean {

    if (this.isEditForExistingItem) {
      this.isEditDisabled = true;
    }

    if (this.isEditForNewItem) {
      this.isEditDisabled = false;
    }

    return this.isEditDisabled;
  }

}
